import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import './index2.js';
import { D as DomService } from './index3.js';

var RocheListType;
(function (RocheListType) {
    RocheListType["ORDERED"] = "ordered";
    RocheListType["UNORDERED"] = "unordered";
})(RocheListType || (RocheListType = {}));

const rocheListCss = "roche-list>ol,roche-list>ul{list-style:none;counter-reset:li;padding:0}roche-list>ol>li>*,roche-list>ul>li>*{margin-top:0}roche-list.--showEnumeration>ol,roche-list.--showEnumeration>ul{padding-left:1.25rem}roche-list.--showEnumeration>ol>li,roche-list.--showEnumeration>ul>li{display:flex}roche-list.--showEnumeration>ol>li::marker,roche-list.--showEnumeration>ul>li::marker{content:\"\"}roche-list.--showEnumeration>ol>li{counter-increment:li}roche-list.--showEnumeration>ol>li::before{vertical-align:top;content:counter(li) \".\";color:#06c;display:inline-block;width:1.25rem;margin-left:-1.25rem}roche-list.--showEnumeration>ul{padding-left:0.625rem}roche-list.--showEnumeration>ul>li::before{font-family:RocheIconFont, serif;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;display:inline-block;font-size:1em;margin-right:5px;content:\"\\e03d\";font-size:0.75rem;vertical-align:top;display:inline-block;width:0.9375rem;margin-left:-0.625rem;color:#06c}roche-list.--showEnumeration>ul roche-list.--showEnumeration>ul>li::before{content:\"\\e045\"}roche-list[dir=rtl].--showEnumeration>ol,roche-list[dir=rtl].--showEnumeration>ul{padding-right:1.25rem;padding-left:0}roche-list[dir=rtl]>ol>li::before{margin-right:-1.25rem;margin-left:0}roche-list[dir=rtl]>ul>li::before{margin-right:-1.25rem;margin-left:5px}";
const RocheListStyle0 = rocheListCss;

const RocheList$1 = /*@__PURE__*/ proxyCustomElement(class RocheList extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.type = RocheListType.UNORDERED;
        this.showEnumeration = false;
    }
    componentDidLoad() {
        DomService.handleTextDirection(this.element);
    }
    render() {
        const hostClasses = {
            '--isUnordered': this.type === RocheListType.UNORDERED,
            '--showEnumeration': this.showEnumeration,
        };
        return (h(Host, { key: '2304e2ef482e708b3c971db1f87274894c5d66da', class: hostClasses }, h("slot", { key: 'cfdc4a5fbd5866c03a968c2d9ff88dea85e7e1c5', name: "items" })));
    }
    get element() { return this; }
    static get style() { return RocheListStyle0; }
}, [4, "roche-list", {
        "type": [1],
        "showEnumeration": [4, "show-enumeration"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-list"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-list":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheList$1);
            }
            break;
    } });
}

const RocheList = RocheList$1;
const defineCustomElement = defineCustomElement$1;

export { RocheList, defineCustomElement };

//# sourceMappingURL=roche-list.js.map